interface LoadingSkeletonProps {
  variant?: 'table' | 'card' | 'text' | 'grid';
  rows?: number;
  cols?: number;
}

export function LoadingSkeleton({ variant = 'table', rows = 5, cols = 5 }: LoadingSkeletonProps) {
  if (variant === 'table') {
    return (
      <div className="bg-night border border-stone/30 rounded-xl overflow-hidden">
        <div className="animate-pulse">
          {/* Table header */}
          <div className="bg-stone/20 border-b border-stone/30 px-4 py-3 flex gap-4">
            {Array.from({ length: cols }).map((_, i) => (
              <div key={i} className="h-4 bg-stone/50 rounded flex-1"></div>
            ))}
          </div>
          {/* Table rows */}
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <div
              key={rowIndex}
              className="border-b border-stone/20 last:border-0 px-4 py-3 flex gap-4"
            >
              {Array.from({ length: cols }).map((_, colIndex) => (
                <div key={colIndex} className="h-4 bg-stone/50 rounded flex-1"></div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (variant === 'card') {
    return (
      <div className="bg-night border border-stone/30 rounded-xl p-4">
        <div className="animate-pulse space-y-2">
          <div className="h-4 bg-stone/50 rounded w-1/2"></div>
          <div className="h-8 bg-stone/50 rounded w-3/4"></div>
          <div className="h-3 bg-stone/50 rounded w-1/3"></div>
        </div>
      </div>
    );
  }

  if (variant === 'grid') {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="bg-night border border-stone/30 rounded-xl p-4">
            <div className="animate-pulse space-y-2">
              <div className="h-4 bg-stone/50 rounded w-1/2"></div>
              <div className="h-8 bg-stone/50 rounded w-3/4"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  // text variant
  return (
    <div className="animate-pulse space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="h-4 bg-stone/50 rounded"
          style={{ width: `${Math.random() * 40 + 60}%` }}
        ></div>
      ))}
    </div>
  );
}
